import MasqueradeWidget from './MasqueradeWidget';

export default MasqueradeWidget;
